var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TransientPipeExport_1;
import '@symon-ai/wisepipe-common-connection'; // force import for JsonSchemaV2
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import './exportSettings'; // force import for JsonSchemaV2
import '@symon-ai/wisepipe-common'; // force import for JsonSchemaV2
import { transientPipeExportSchemaValidation } from '../validations.generated';
export const transientPipeExportSchema = {
    $id: 'urn:wisepipe-common-export:TransientPipeExport',
    type: 'object',
    properties: {
        exportSettings: { $ref: 'urn:wisepipe-common-export:ExportSettings' },
        connection: { $ref: 'urn:wisepipe-common-connection:Connection' },
        credentials: { $ref: 'urn:wisepipe-common:Credentials' },
        connID: { type: 'string', uid: 9 }
    },
    required: ['exportSettings']
};
// wrapper obj to hold the data needed for transient pipe export connectors
let TransientPipeExport = TransientPipeExport_1 = class TransientPipeExport {
    constructor(exportSettings, connection, credentials, connID) {
        this.exportSettings = exportSettings;
        this.connection = connection;
        this.credentials = credentials;
        this.connID = connID;
        // this check can be done in AJV, but same check cannot be done in transientDataConfig so we leave the check like this
        // NOTE: this does not check on deserialization
        const hasConnCreds = this.connection !== undefined && this.credentials !== undefined;
        if (!(hasConnCreds || connID !== undefined)) {
            throw new Error('`Connection and credentials, or a valid connection ID is required export type: ' + exportSettings.exportType);
        }
        JSON.validate(this, TransientPipeExport_1);
    }
};
TransientPipeExport = TransientPipeExport_1 = __decorate([
    JsonSchemaV2(transientPipeExportSchema, transientPipeExportSchemaValidation)
], TransientPipeExport);
export { TransientPipeExport };
//# sourceMappingURL=transientPipeExport.js.map